import { Pipe, PipeTransform } from '@angular/core';

/**
 * Distinct pipe for hashtags
 */
@Pipe({
  name: 'distincthashtags'
})
export class DistincthashtagsPipe implements PipeTransform {
  /**
   * Transforms the input: DISTINCT
   * @param value
   * @returns
   */
  transform(value: any[]): any[] {
    if (!Array.isArray(value)) {
      return value;
    }

    const distinctMap = new Map<string, boolean>();
    const result = [];

    for (const item of value) {
      if (item?.key) {
        const key = item.key;
        if (!distinctMap.has(key)) {
          distinctMap.set(key, true);
          result.push(item);
        }
      }
    }

    return result;
  }
}
